import ApiService from "../common/api.service";
import { FETCH_FIELDS, FETCH_FIELDS_OVERVIEW } from "./actions.type";
import { SET_FIELDS, SET_FIELDS_OVERVIEW } from "./mutations.type";

const state = {
  allFields: null,
  allFieldsOverview: {}
};

const getters = {
  getAllFields: state => state.allFields,
  getAllFieldsOverview: state => state.allFieldsOverview
};

const actions = {
  async [FETCH_FIELDS]({ commit }, payload) {
    await ApiService.setHeader();
    try {
      const { data } = await ApiService.get(`courts/${payload.courtId}/fields`);

      commit(SET_FIELDS, data.data);
    } catch (error) {
      console.log("err saveFields", error);
    }
  },
  async [FETCH_FIELDS_OVERVIEW]({ commit }, payload) {
    await ApiService.setHeader();
    try {
      const { data } = await ApiService.get(
        `dashboard/courts/${payload.courtId}/skillcourt/fields-overview/${payload.time}/?page=${payload.page}`
      );
      commit(SET_FIELDS_OVERVIEW, data);
    } catch (error) {
      console.log("err saveFieldsOverview", error);
    }
  }
};

const mutations = {
  [SET_FIELDS](state, payload) {
    state.allFields = payload;
  },
  [SET_FIELDS_OVERVIEW](state, payload) {
    state.allFieldsOverview = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
